export default __webpack_public_path__ + "assets/images/c2f40fd85759fc7683a3fefad2cec784.jpg";